/* global femcare */

femcare.ctaPanel.quickBuy = {
    $quickBuyButton: $('.cta-panel .cta-panel__quick-buy-button'),
    productsData: window.pr_render_quick_buy_data,
    $quickBuyModal: $('.modal--quick-buy'),

    init: function () {
        this.isSearchPage();

        if (this.$quickBuyButton.length && this.productsData.length) {
            this.openModal();
        }
    },

    generateModal: function (id) {
        var $modal = this.$quickBuyModal;

        this.productsData.forEach(function (element) {
            var productId = element.ProductId;

            if (productId === id) {
                var productContent = element.detailQuickBuyHtml;
                var parser = new DOMParser();
                var parsedContent = parser.parseFromString(productContent, 'text/html');
                var contentToUse = parsedContent.activeElement;
                $modal.find('.modal__body').html(contentToUse);
            }
        })

        var $product = $modal.find('.product-main--shop-slim');
        var productId = $product[0].dataset.productid;
        var productReviewComponent = $product[0].dataset.productReviewComponents;

        this.renderPowerReviews(productId, productReviewComponent);
        setTimeout(() => {
            femcare.product.panel.info.shop.mainPanelSlim($product);
        }, 10);
    },

    openModal: function () {
        this.$quickBuyButton.on('click', (e) => {
            e.preventDefault();

            // Each time modal for quick buy is opened we want to reset previously selected options for product
            femcare.product.panel.info.shop.resetSelectedOptions();

            var productId = e.target.dataset.productid;
            this.generateModal(productId);
        })
    },

    renderPowerReviews: function (productId, productReviewComponent) {
        var isPowerReviewsLoaded = window.POWERREVIEWS;
        if (isPowerReviewsLoaded) {
            var pr_render_options = window.pr_render_options || []
            pr_render_options.forEach(function (element, index) {
                var reviewSnippetId = pr_render_options[index].page_id;

                if (reviewSnippetId === productId) {
                    var renderData = pr_render_options[index];
                    var componentsData = JSON.parse(productReviewComponent)
                    renderData.components = componentsData;
                    window.POWERREVIEWS.display.render(renderData);
                }
            })
        }
    },

    isSearchPage: function () {
        var searchPageIndicator = $('.search-results');

        if (searchPageIndicator.length) {
            this.$quickBuyButton = $('.cta-panel .cta-panel__quick-buy-button');
        }
    }
}